import {getRouter} from "@/router";

async function routeToUrl(name: string, params: Record<string, string>) {
    const router = await getRouter();
    return (
        window.location.protocol +
        "//" +
        window.location.host +
        process.env.BASE_URL +
        "index.html" +
        router.resolve({name, params}).href
    );
}

export async function toLogin(force = false) {
    const router = await getRouter();
    const name = router.currentRoute.value.name;
    const redirect = router.currentRoute.value.fullPath;
    if (force || name !== 'login') {
        await router.push({name: "login", query: {redirect}})
    }
}
